import React, { useState } from "react";
import dayjs from "dayjs";

import getApiErrorMessage from "../../../../utils/getApiErrorMessage";
import useRelatoriosAgendaCare from "../../data/hooks/useRelatoriosAgendaCare";
import CardsResumoRelatorio from "./components/CardsResumoRelatorio";
import FiltrosRelatorios from "./components/FiltrosRelatorios";
import RankingPacientes from "./components/RankingPacientes";
import RankingProcedimentos from "./components/RankingProcedimentos";
import TabelaAtendimentosEnfermeiro from "./components/TabelaAtendimentosEnfermeiro";

function obterPeriodoPadrao() {
  const dataFinal = dayjs().endOf("day");

  return {
    dataInicial: dataFinal.subtract(30, "day").startOf("day"),
    dataFinal,
  };
}

export default function RelatoriosAgendaCare() {
  const [dataInicial, setDataInicial] = useState(() => obterPeriodoPadrao().dataInicial);
  const [dataFinal, setDataFinal] = useState(() => obterPeriodoPadrao().dataFinal);
  const [enfermeiroId, setEnfermeiroId] = useState("");
  const [filtrosAplicados, setFiltrosAplicados] = useState(() => ({
    ...obterPeriodoPadrao(),
    enfermeiroId: "",
  }));
  const { relatorio, loading, error } = useRelatoriosAgendaCare(filtrosAplicados);

  const handleAplicarFiltros = () => {
    setFiltrosAplicados({
      dataInicial,
      dataFinal,
      enfermeiroId,
    });
  };

  const handleChangeEnfermeiro = (event) => {
    const novoEnfermeiroId = event.target.value;
    setEnfermeiroId(novoEnfermeiroId);
    setFiltrosAplicados({
      dataInicial,
      dataFinal,
      enfermeiroId: novoEnfermeiroId,
    });
  };

  const mensagemErro = error
    ? getApiErrorMessage(error, "Não foi possível carregar os relatórios.")
    : "";

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1180px",
        margin: "0 auto",
        padding: "0 8px 32px",
        boxSizing: "border-box",
      }}
    >
      <FiltrosRelatorios
        dataInicial={dataInicial}
        setDataInicial={setDataInicial}
        dataFinal={dataFinal}
        setDataFinal={setDataFinal}
        onAplicarFiltros={handleAplicarFiltros}
      />

      {loading && (
        <div style={{ marginTop: "16px", color: "#7C8798", fontSize: "14px" }}>
          Carregando relatórios...
        </div>
      )}

      {mensagemErro && (
        <div style={{ marginTop: "16px", color: "#C62828", fontSize: "14px" }}>
          {mensagemErro}
        </div>
      )}

      <CardsResumoRelatorio resumo={relatorio?.resumo} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        <RankingPacientes
          titulo="Pacientes e quantidade de atendimentos"
          subtitulo="Top 5 pacientes por volume de atendimentos"
          itens={relatorio?.topPacientesAtendimentos || []}
        />
        <RankingPacientes
          titulo="Valor investido por paciente"
          subtitulo="Pacientes com maior gasto acumulado"
          itens={relatorio?.topPacientesInvestimento || []}
          tipo="valor"
        />
      </div>

      <TabelaAtendimentosEnfermeiro
        enfermeiroId={enfermeiroId}
        onChangeEnfermeiro={handleChangeEnfermeiro}
        atendimentos={relatorio?.atendimentosPorEnfermeiro || []}
        totalAtendimentos={relatorio?.totalAtendimentosEnfermeiros || 0}
      />

      <RankingProcedimentos itens={relatorio?.procedimentosMaisRealizados || []} />
    </div>
  );
}
